import { Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject, Subscription } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { Shop } from "../models/shop.model";
import { AlertService, MessageSeverity } from "./alert.service";
import { AuthService } from "./auth.service";
import { ShopEndpointService } from "./shop-endpoint.service";

@Injectable()
export class ShopService implements OnDestroy {

  public allShopsChanged: BehaviorSubject<Shop[]> = new BehaviorSubject<Shop[]>(null);
  private updateAllShopsChange: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  private updateShopsSubscription: Subscription;
  private logoutSubscription: Subscription;

  constructor(private shopEndpointService: ShopEndpointService, private alertService: AlertService,
    private authService: AuthService) {

    this.logoutSubscription = this.authService.logoutEmitter.subscribe(logout => {
      if (logout == false) {
        this.updateAllShops();
      }
    });

    // Aktualisierung der Shops zusammenfassen, damit nicht zwei Anfragen
    // zur fast gleichen Zeit an den Server gehen
    this.updateShopsSubscription = this.updateAllShopsChange
      .pipe(
        debounceTime(10),
      )
      .subscribe(res => {
        this.updateAllShopsExecute();
      });
  }

  ngOnDestroy(): void {
    if (this.logoutSubscription) {
      this.logoutSubscription.unsubscribe();
    }
    if (this.updateShopsSubscription) {
      this.updateShopsSubscription.unsubscribe();
    }
  }

  public updateAllShops() {
    this.updateAllShopsChange.next(true);
  }

  public updateAllShopsExecute() {
    if (this.authService.isLoggedIn) {
      this.getAllShops().then(shops => {
        this.allShopsChanged.next(shops);
      }).catch(error => {

      });
    }
  }

  public get allShops(): Shop[] {
    return this.allShopsChanged.value;
  }

  private getAllShops(): Promise<Shop[]> {
    return new Promise((resolve, reject) => {
      return this.shopEndpointService.getAllShops(false).subscribe({
        next: shops => {
          resolve(shops);
        },
        error: error => {
          this.alertService.showMessage('Serverfehler', 'Beim Laden der Betriebsstätten ist ein Fehler aufgetreten!', MessageSeverity.error);
          reject();
        }
      });
    });
  }

  public getShop(id: string): Promise<Shop> {
    return new Promise((resolve, reject) => {
      return this.shopEndpointService.get(id, false).subscribe({
        next: shop => {
          resolve(shop);
        },
        error: error => {
          this.alertService.showMessage('Serverfehler', 'Beim Laden der Betriebsstätte mit der ID ' + id + ' ist ein Fehler aufgetreten!', MessageSeverity.error);
          reject();
        }
      });
    });
  }

}
